import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowRight, Calendar } from 'lucide-react';

const Blogs = () => {
  const blogPosts = [
    {
      id: 'polyester-tape-guide',
      title: 'Complete Guide to Double-Sided Polyester Tape: Applications & Benefits',
      excerpt: 'Discover why double-sided polyester tape is the preferred choice for industrial bonding, laminating, and splicing applications.',
      image: '/site-assets/poly2.jpg',
      date: 'January 10, 2025',
      category: 'Polyester Tapes'
    },
    {
      id: 'high-temperature-masking',
      title: 'High-Temperature Masking Tape: Essential Guide for Powder Coating',
      excerpt: 'Learn how green polyester masking tape withstands extreme temperatures in powder coating, anodizing, and electroplating processes.',
      image: '/site-assets/poly1.jpg',
      date: 'January 8, 2025',
      category: 'Polyester Tapes'
    },
    {
      id: 'electrical-insulation-tapes',
      title: 'Electrical Insulation Tapes: Choosing the Right Solution for Motors & Transformers',
      excerpt: 'A comprehensive guide to selecting electrical insulation tapes for motors, transformers, and high-temperature applications.',
      image: '/site-assets/poly3.jpg',
      date: 'January 5, 2025',
      category: 'Insulation Tapes'
    },
    {
      id: 'epdm-foam-tape-sealing',
      title: 'EPDM Foam Tape: Ultimate Weather Sealing Solution for HVAC Applications',
      excerpt: 'Explore how EPDM foam tape provides superior weatherproofing and sealing for HVAC, automotive, and construction projects.',
      image: '/site-assets/epdm.jpg',
      date: 'January 3, 2025',
      category: 'Foam Tapes'
    },
    {
      id: 'kapton-tape-applications',
      title: 'Polyimide (Kapton) Tape: High-Performance Solution for Aerospace & Electronics',
      excerpt: 'Understanding the unique properties of Kapton tape and its critical applications in aerospace, electronics, and high-temperature environments.',
      image: '/site-assets/polyimide.png',
      date: 'December 28, 2024',
      category: 'Specialty Tapes'
    },
    {
      id: 'aluminum-foil-tape-hvac',
      title: 'Aluminum Foil Tape for HVAC: Complete Installation & Application Guide',
      excerpt: 'Master the use of aluminum foil tape for duct sealing, thermal insulation, and EMI/RFI shielding in HVAC systems.',
      image: '/site-assets/aluminum.jpg',
      date: 'December 25, 2024',
      category: 'Specialty Tapes'
    },
    {
      id: 'cross-filament-tape-packaging',
      title: 'Cross Filament Tape: Heavy-Duty Packaging & Strapping Solutions',
      excerpt: 'Learn why cross filament tape is the go-to choice for heavy-duty packaging, palletizing, and load securing applications.',
      image: '/site-assets/cross-filament.jpeg',
      date: 'December 20, 2024',
      category: 'Specialty Tapes'
    },
    {
      id: 'neoprene-foam-construction',
      title: 'Neoprene Foam Tape in Construction: Sealing, Insulation & Vibration Control',
      excerpt: 'Discover how neoprene foam tape provides excellent sealing, insulation, and vibration dampening for construction projects.',
      image: '/site-assets/neo.jpg',
      date: 'December 15, 2024',
      category: 'Foam Tapes'
    },
    {
      id: 'die-cuts-custom-solutions',
      title: 'Custom Die-Cut Adhesive Solutions: Design, Materials & Applications',
      excerpt: 'Explore the world of custom die-cut tapes and how precision cutting creates perfect solutions for your unique applications.',
      image: '/site-assets/diecut.jpeg',
      date: 'December 10, 2024',
      category: 'Specialty Tapes'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 via-white to-orange-50 py-20 lg:py-32">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Adhesive Tape <span className="text-orange-600">Insights & Guides</span>
            </h1>
            <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
              Expert knowledge, application guides, and industry insights from Shriram Spectape
            </p>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 lg:py-28">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <Card key={post.id} className="hover:shadow-xl transition-shadow border-2 hover:border-orange-200 overflow-hidden">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <CardHeader>
                  <div className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
                    <Calendar className="h-4 w-4" />
                    <span>{post.date}</span>
                    <span className="text-orange-600">• {post.category}</span>
                  </div>
                  <CardTitle className="text-xl leading-tight">{post.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base mb-4">
                    {post.excerpt}
                  </CardDescription>
                  <Link to={`/blog/${post.id}`}>
                    <Button className="bg-orange-600 hover:bg-orange-700 text-white w-full">
                      Read More
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;